import styled from "styled-components";
import { lightblue, darkblue, mazarine } from "../../styles/variables.style";

export const EasyNewsWrapper = styled.div`
  padding-right: 15%;
  padding-left: 15%;
  padding-top: 100px;

  .coverpic {
    &,
    span {
      width: 100% !important;
    }
  }

  h1 {
    font-weight: bold;
    font-size: 42px;
    margin-bottom: 5px;
  }

  .description {
    font-size: 19px;
  }

  .ant-select {
    margin-bottom: 50px;
    width: 200px;
  }

  .articlesWrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    margin-bottom: 50px;
    > div {
      margin-top: 0px;
      margin-left: 0px;
    }
    .article {
      flex: 1;
    }
  }

  .noArticle {
    margin-top: 50px;
    margin-bottom: 50px;
  }

  @media (max-width: 1024px) {
    > div {
      padding-right: 3%;
      padding-left: 3%;
    }
    .barre {
      .btn_haut {
        height: 30px;
        font-size: 20px;
      }
    }
    .rechercheTags {
      flex-direction: column;
      .btns_tag {
        margin-left: auto;
        margin-right: auto;
        .ant-checkbox-group {
          flex-direction: row;
        }
      }
    }
  }

  @media (max-width: 1024px) {
    padding-top: 20px;
    padding-left: 3%;
    padding-right: 3%;
    .filters {
      margin-top: 0px;
      flex-direction: column;
      align-items: center;
      margin-bottom: 20px;
      .ant-btn {
        width: 80%;
        margin-bottom: 10px;
        margin-right: 0px;
      }
    }
    .ant-select {
      width: 100%;
    }
  }
`;
